<template>
      <div class="center-center">
      <span class="center-title">最新文章</span>
      <div v-for="article in articles" :key="article.id" class="article">
        <div class="category">
          <span>{{ article.category }}</span>
        </div>
        <div class="article-title">
          <RouterLink :to="{name: 'post', params: {id: article.id}}">
            {{ article.title }}
          </RouterLink>
        </div>
        <div class="article-content">{{ article.summary }}</div>
        <div class="article-info">
          <div>
            <span class="iconfont icon-riqishijian_line"></span>
            <span>{{ article.create_time }}</span>
          </div>
          <div>
            <span class="iconfont icon-tushu"></span>
            <span>{{ article.words }}字</span>
          </div>
          <div>
            <span class="iconfont icon-zuozhe"></span>
            <span>{{ article.username }}</span>
          </div>
          <div class="article-label">
            <span class="iconfont icon-biaoqian"></span>
            <div class="label-spans">
              <span class="article-label-span">#{{ article.tag }}</span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <pagePagination @update:currentpage="handleClickPage" :islastpage="islastpage" :totalpage="totalpage" :currentPage="currentPage" />
        <!-- <pagePagination /> -->
      </div>
    </div>
    <div class="center-right">
      <div class="search-box">
        <span class="iconfont icon-search"></span>
        <input placeholder="搜索...">
      </div>
      <div class="category-box">
        <div class="category-title noselect">
          <span class="iconfont icon-leibiemoban"></span>分类
        </div>
        <div class="category-content">
          <span v-for="category in categories" :key="category.category_code" class="category noselect">{{ category.category_name }}</span>
        </div>
      </div>
      <div class="label-box">
        <div class="label-title noselect">
          <span class="iconfont icon-biaoqian"></span>标签
        </div>
        <div class="label-content">
          <span v-for="tag in tags" :key="tag.tag_code" class="label noselect">#{{ tag.tag_name }}</span>
        </div>
      </div>
    </div>
</template>

<script>
import { ref, inject } from 'vue'
import pagePagination from '@/components/pagePagination.vue'
import request from '@/utils/request'
import Cookies from 'js-cookie'
export default {
  name: 'HomeHome',
  components: { pagePagination },
  setup () {
    const { articles, totalpage, islastpage, currentPage, categories, tags } = inject('articleData')
    const loading = ref(true)
    const isLogin = ref(false)
    const userid = ref(undefined)

    // const doneLoading = inject('doneLoading')
    // 初始化请求文章接口
    const getAllArticle = (page) => {
      return request('/article/all', 'get', { nextpage: page }).then(
        response => {
          articles.value = response.data.articles
          totalpage.value = response.data.totalpage
          islastpage.value = response.data.islastpage
          console.log('请求结果', response.data)
        }
      ).catch(err => {
        console.log('请求出错了', err)
      })
    }

    const handleClickPage = (newPage) => {
      getAllArticle(newPage)
      currentPage.value = newPage
      // 获取实际滚动容器
      const scrollContainer = document.querySelector('.home-index')
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    }

    const logout = () => {
      Cookies.remove('userid', { path: '/' })
      Cookies.remove('token', { path: '/' })
      isLogin.value = false
    }

    return {
      getAllArticle,
      articles,
      islastpage,
      totalpage,
      currentPage,
      handleClickPage,
      categories,
      loading,
      logout,
      isLogin,
      userid,
      tags
    }
  }
}
</script>

<style lang="less" scoped>
.center-center {
  flex: 4;
  padding: 10px 5px;
  .category{
    span {
      background-color: #999;
      padding: 5px;
      border-radius: 7px;
    }
  }
  .center-title {
    margin-left: 15px;
    // background-color: #999;
    font-size: 18px;
  }
  .article {
    margin: 10px auto;
    padding: 25px;
    // border: 2px solid;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background-color: rgb(255, 255, 255);
    .article-title {
      font-size: 26px;
      font-weight: 600;
    }
    .article-content {
      font-size: 14px;
      font-weight: 400;
      // border: 2px dashed rgb(150, 150, 150);
      padding: 15px 10px;
      border-radius: 10px;
      background-color: rgb(240, 240, 240);
    }
    .article-info {
      display: flex;
      column-gap: 40px;
      flex-wrap: wrap;
    }
    .article-label {
      display: flex;
      gap: 0px;
      .iconfont {
        font-size: 14px;
      }
      .label-spans {
        display: flex;
        gap: 10px;
        .article-label-span {
          padding: 0 7px;
          background-color: rgb(236, 253, 245);
          border-radius: 6px;
          border: 1px solid rgb(209, 250, 229)
        }
      }
    }
  }
}
.center-right {
  flex: 1;
  padding-top: 10px;
  position: sticky;
  top: 0;
  max-height: 100vh;
  @media (max-width: 768px) {
    display: none;
  }
  .search-box {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 20px;
    padding: 10px;
    background-color: rgb(255, 255, 255);
    input {
      flex: 1;
      font-size: 14px;
    }
    .iconfont {
      line-height: 1;
      font-size: 18px;
      color: #999
    }
  }
  .category-box {
    margin-top: 10px;
    // background-color: rgb(255, 255, 255);
    padding: 10px 10px;
    .category-title {
      margin-bottom: 10px;
    }
    .category-content {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
      .category {
        background-color: rgb(81, 118, 81);
        padding: 5px;
        border-radius: 7px;
      }
    }
  }
  .label-box {
    margin-top: 10px;
    // background-color: rgb(255, 255, 255);
    padding: 10px 10px;
    height: 300px;
    border-radius: 20px;
    .label-content {
      display: flex;
      column-gap: 10px;
      margin-top: 10px;
      .label {
        background-color: rgb(255, 255, 255);
        padding: 5px;
        border-radius: 7px;
      }
    }
  }
}
</style>>
